
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-65524315!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-65524315!../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/App.vue
// module id = 163
// module chunks = 0